import {all, takeEvery} from 'redux-saga/effects'

import AddReturnOrderCommentModal from './AddReturnOrderCommentModal.js'
import AssignReturnOrderLineCodeModal, {
  ASSIGN_RETURN_ORDER_LINE_CODE,
  assignReturnOrderLineCodeWorker,
} from './AssignReturnOrderLineCodeModal.js'
import CancelReturnOrdersModal, {
  CANCEL_RETURN_ORDERS,
  cancelReturnOrdersWorker,
} from './CancelReturnOrdersModal.js'
import CreateReturnOrderModal from './CreateReturnOrderModal/index.js'
import DeleteReturnOrderLabelsModal, {
  DELETE_RETURN_ORDER_LABELS,
  deleteReturnOrderLabelsWorker,
} from './DeleteReturnOrderLabelsModal.js'
import DeleteReturnOrderLinesModal, {
  DELETE_RETURN_ORDER_LINES,
  deleteReturnOrderLinesWorker,
} from './DeleteReturnOrderLinesModal.js'
import EditRMALineModal from './EditRMALineModal.js'
import EmailReturnOrdersModal, {
  EMAIL_RETURN_ORDERS,
  emailReturnOrdersWorker,
} from './EmailReturnOrdersModal.js'
import ReceiveReturnOrderModal from './ReceiveReturnOrderModal.js'
import UpdateReturnOrderCustomerNotesModal, {
  SHOW_UPDATE_RETURN_ORDER_CUSTOMER_NOTES_MODAL,
  UPDATE_RETURN_ORDER_CUSTOMER_NOTES,
  showUpdateReturnOrderCustomerNotesModalWorker,
  updateReturnOrderCustomerNotesWorker,
} from './UpdateReturnOrderCustomerNotesModal.js'
import UpdateReturnOrderInternalNotesModal, {
  SHOW_UPDATE_RETURN_ORDER_INTERNAL_NOTES_MODAL,
  UPDATE_RETURN_ORDER_INTERNAL_NOTES,
  showUpdateReturnOrderInternalNotesModalWorker,
  updateReturnOrderInternalNotesWorker,
} from './UpdateReturnOrderInternalNotesModal.js'
import UpdateReturnOrderLineNotesModal, {
  SHOW_UPDATE_RETURN_ORDER_LINE_NOTES_MODAL,
  UPDATE_RETURN_ORDER_LINE_NOTES,
  showUpdateReturnOrderLineNotesModalWorker,
  updateReturnOrderLineNotesWorker,
} from './UpdateReturnOrderLineNotesModal.js'
import UpdateReturnOrdersStatusModal, {
  UPDATE_RETURN_ORDERS_STATUS,
  updateReturnOrdersStatusWorker,
} from './UpdateReturnOrdersStatusModal.js'

export default function Modals() {
  return (
    <>
      <AddReturnOrderCommentModal />
      <AssignReturnOrderLineCodeModal />
      <CancelReturnOrdersModal />
      <CreateReturnOrderModal />
      <DeleteReturnOrderLabelsModal />
      <DeleteReturnOrderLinesModal />
      <EditRMALineModal />
      <EmailReturnOrdersModal />
      <ReceiveReturnOrderModal />
      <UpdateReturnOrderCustomerNotesModal />
      <UpdateReturnOrderInternalNotesModal />
      <UpdateReturnOrderLineNotesModal />
      <UpdateReturnOrdersStatusModal />
    </>
  )
}

export function* returnOrderListModalsSaga() {
  yield all([
    takeEvery(ASSIGN_RETURN_ORDER_LINE_CODE, assignReturnOrderLineCodeWorker),
    takeEvery(CANCEL_RETURN_ORDERS, cancelReturnOrdersWorker),
    takeEvery(DELETE_RETURN_ORDER_LABELS, deleteReturnOrderLabelsWorker),
    takeEvery(DELETE_RETURN_ORDER_LINES, deleteReturnOrderLinesWorker),
    takeEvery(EMAIL_RETURN_ORDERS, emailReturnOrdersWorker),
    takeEvery(
      SHOW_UPDATE_RETURN_ORDER_CUSTOMER_NOTES_MODAL,
      showUpdateReturnOrderCustomerNotesModalWorker,
    ),
    takeEvery(
      UPDATE_RETURN_ORDER_CUSTOMER_NOTES,
      updateReturnOrderCustomerNotesWorker,
    ),
    takeEvery(
      SHOW_UPDATE_RETURN_ORDER_INTERNAL_NOTES_MODAL,
      showUpdateReturnOrderInternalNotesModalWorker,
    ),
    takeEvery(
      UPDATE_RETURN_ORDER_INTERNAL_NOTES,
      updateReturnOrderInternalNotesWorker,
    ),
    takeEvery(
      SHOW_UPDATE_RETURN_ORDER_LINE_NOTES_MODAL,
      showUpdateReturnOrderLineNotesModalWorker,
    ),
    takeEvery(UPDATE_RETURN_ORDER_LINE_NOTES, updateReturnOrderLineNotesWorker),
    takeEvery(UPDATE_RETURN_ORDERS_STATUS, updateReturnOrdersStatusWorker),
  ])
}
